import { useState, useEffect } from 'react';
import { FaWhatsapp, FaArrowUp } from 'react-icons/fa';
import './FloatingWidgets.css';

const FloatingWidgets = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScroll(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <a href="https://wa.me/2349150196438" class="whatsapp-float" target="_blank" rel="noopener noreferrer" aria-label="Chat with Choir Center on WhatsApp">

        <FaWhatsapp size={28} />
      </a>
      {showScroll && (
        <button className="scroll-to-top" onClick={scrollToTop}>
          <FaArrowUp size={18} />
        </button>
      )}
    </>
  );
};

export default FloatingWidgets;
